export class CountBySubCategoriesReq{
	date : Date;
	divisionId : number;
	clientCode : string;
	categoryId : number ;
    subCategoryId : number ;
}